'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { useState } from 'react';

import { buildImageSizes } from '@eliadmin/core/src/components/image/image-helpers';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const ReferenceGallery = ({ reference }: { reference: Reference }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState([]);
  const imagesWithUrl = reference.images.filter(image => image?.url?.trim());

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <section className={cn('custom-section')}>
        <div className={cn('custom-container', 'flex flex-col items-start justify-start gap-8')}>
          <HtmlRendererRaw className="w-full max-w-[750px]" html={reference.description} />
          {imagesWithUrl.length > 0 && (
            <div className="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
              {imagesWithUrl.map((image, index) => (
                <div
                  key={index}
                  onClick={handleOpenGallery(imagesWithUrl, index)}
                  className="relative col-span-1 h-[250px] w-full overflow-hidden rounded-[8px] sm:h-[320px]"
                >
                  <Image
                    src={image.url.trim()}
                    alt={resolveImageAlt(image, reference?.name)}
                    fill
                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                    sizes={buildImageSizes([
                      { min: 'lg', size: '25vw' },
                      { min: 'sm', size: '50vw' },
                      { size: '100vw' },
                    ])}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};
